import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";

function Flag({ tone = "amber", testid, children }) {
  const cls = tone === "gray" ? "bg-gray-100 border-gray-200 text-gray-700" : "bg-amber-50 border-amber-200 text-amber-800";
  return (
    <div className={`rounded-xl border p-3 text-sm flex gap-2 ${cls}`} data-testid={testid}>
      <AlertTriangle className="w-4 h-4 shrink-0 mt-0.5" /><div className="space-y-1">{children}</div>
    </div>
  );
}

const DUP_TEXT = {
  pending_review: "Possible duplicate — waiting for a manager to approve or decline the exception. It cannot be submitted until approved.",
  approved: "Manager-approved duplicate exception.",
  declined: "Duplicate exception declined. Correct the invoice number or discard this draft.",
};
const EXC_TEXT = {
  pending: "No receipt — waiting for a manager to approve the exception before submission.",
  approved: "No-receipt exception approved by a manager.",
  declined: "No-receipt exception declined. Attach a receipt to continue.",
};

export default function RecordFlags({ data, entity }) {
  const excDecision = [...(data.history || [])].reverse().find((h) => /^no_receipt_exception_(approved|declined)$/.test(h.action));
  return (
    <>
      {data.status === "voided" && <Flag tone="gray" testid="void-flag"><p className="font-medium">Voided: “{data.void_reason}”</p><p>Kept for the audit trail; excluded from totals.</p></Flag>}
      {entity === "purchases" && data.duplicate_status && (
        <Flag testid="duplicate-flag">
          <p className="font-medium">{DUP_TEXT[data.duplicate_status]}</p>
          {data.duplicate_request_reason && <p>Employee reason: “{data.duplicate_request_reason}”</p>}
          {data.duplicate_decision_reason && <p>Manager reason ({data.duplicate_decided_by_name}): “{data.duplicate_decision_reason}”</p>}
          {data.duplicate_of && <Link className="inline-flex min-h-[44px] items-center font-medium text-gold" to={`/view-purchase/${data.duplicate_of.id}`} data-testid="duplicate-of-link">Open the original invoice</Link>}
        </Flag>
      )}
      {entity === "purchases" && data.cross_store_ack && <Flag testid="cross-store-flag"><p>The submitter was warned that this supplier invoice number may also exist at another store, and confirmed it is for this store.</p></Flag>}
      {entity === "expenses" && data.exception_status && (
        <Flag testid="exception-flag">
          <p className="font-medium">{EXC_TEXT[data.exception_status]}</p>
          {data.exception_reason && <p>Employee reason: “{data.exception_reason}”</p>}
          {data.exception_decided_by_name && <p>Decided by {data.exception_decided_by_name}{excDecision?.reason ? `: “${excDecision.reason}”` : ""}</p>}
        </Flag>
      )}
    </>
  );
}
